import { Button } from 'slab'

import { useCardPayment } from './payments/CardPaymentProvider'

type Props = {
  isDisabled?: boolean
  isProcessing?: boolean
  coveredByBalance?: boolean
  onCreatePurchase: () => void
}

export default function PurchaseButton ({
  isDisabled,
  isProcessing,
  coveredByBalance,
  onCreatePurchase,
}: Props) {
  const { cardPaymentsEnabled, selectedPaymentMethod } = useCardPayment()

  const isButtonDisabled =
    isDisabled ||
    isProcessing ||
    (!coveredByBalance && (!cardPaymentsEnabled || !selectedPaymentMethod))

  return (
    <Button
      onClick={onCreatePurchase}
      disabled={isButtonDisabled}
      size='large'
      variant='primary'
      width='full'
    >
      {isProcessing ? 'Processing...' : 'Complete purchase'}
    </Button>
  )
}
